import { History } from 'history'
import { routerMiddleware } from 'react-router-redux'
import { applyMiddleware, createStore, Middleware, Store } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import thunk from 'redux-thunk'

import { IRootState, rootReducer } from '../reducers'

export default function configureStore(
  preloadedState?: IRootState,
  history?: History
) {
  const middlewares: Middleware[] = [thunk]
  let reactRouterReduxMiddleware
  if (history) {
    reactRouterReduxMiddleware = routerMiddleware(history)
    middlewares.push(reactRouterReduxMiddleware)
  }

  const enhancer = composeWithDevTools(applyMiddleware(...middlewares))
  const store = preloadedState
    ? createStore(rootReducer, preloadedState, enhancer)
    : createStore(rootReducer, enhancer)

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../reducers', () => {
      const nextRootReducer = require('../reducers').default
      store.replaceReducer(nextRootReducer)
    })
  }

  return store
}
